import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { Layout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'

const { t } = useI18n()

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    redirect: '/agent',
    name: 'Root',
    meta: {
      hidden: true
    }
  },
  // {
  //   path: '/redirect',
  //   component: Layout,
  //   name: 'Redirect',
  //   children: [
  //     {
  //       path: '/redirect/:path(.*)',
  //       name: 'Redirect',
  //       component: () => import('@/views/Redirect/Redirect.vue'),
  //       meta: {}
  //     }
  //   ],
  //   meta: {
  //     hidden: true,
  //     noTagsView: true
  //   }
  // },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('router.login'),
      noTagsView: true
    }
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFind',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  },
  {
    path: '/403',
    component: () => import('@/views/Error/403.vue'),
    name: 'Forbidden',
    meta: {
      hidden: true,
      title: '403',
      noTagsView: true
    }
  }
]

// export const asyncRouterMap: AppRouteRecordRaw[] = [
//   {
//     path: '/',
//     component: Layout,
//     redirect: '/landing-page',
//     name: 'RootPage',
//     meta: {
//       title: t('router.basicInfo'),
//       icon: 'bx:bxs-component',
//       // alwaysShow: true
//     },
//     children: [
//       {
//         path: 'landing-page',
//         component: () => import('@/views/landingPage/index.vue'),
//         name: 'landingPage',
//         meta: {
//           title: t('router.landingPage'),
//           noCache: true,
//           affix: true,
//           hideBreadcrumb:false
//         }
//       }
//     ]
//   },
//   {
//     path: '/doc',
//     component: Layout,
//     redirect: '/doc/device',
//     name: 'DocPage',
//     meta: {
//       title: t('router.knowledgeLibrary'),
//       icon: 'bx:bxs-component',
//       alwaysShow: false
//     },  
//     children: [
//       {
//         path: 'product',
//         component: () => import('@/views/doc/product/index.vue'),
//         name: 'productDoc',
//         meta: {
//           title: t('router.productManual'),
//           noCache: true,
//           affix: true,
//           hideBreadcrumb:false
//         }
//       },
//       {
//         path: 'device',
//         component: () => import('@/views/doc/device/index.vue'),
//         name: 'deviceDoc',
//         meta: {
//           title: t('router.devDoc'),
//           noCache: true,
//           affix: true,
//           hideBreadcrumb:false
//         }
//       },
//     ]
//   },
//   {
//     path: '/encyclopedia',
//     component: Layout,
//     redirect: '/encyclopedia/fault',
//     name: 'Encyclopedia',
//     meta: {
//       title: t('router.knowledgeEncyclopedia'),
//       icon: 'bx:bxs-component',
//       alwaysShow: true
//     },  
//     children: [
//       {
//         path: 'fault',
//         component: () => import('@/views/encyclopedia/fault/index.vue'),
//         name: 'faultEncyclopedia',
//         meta: {
//           title: t('router.faultEncyclopedia'),
//           noCache: true,
//           affix: true,
//           hideBreadcrumb:false
//         }
//       },
//       {
//         path: 'entry',
//         component: () => import('@/views/encyclopedia/entry/index.vue'),
//         name: 'encyclopediaEntry',
//         meta: {
//           title: t('router.encyclopediaEntry'),
//           noCache: true,
//           affix: true,
//           hideBreadcrumb:false
//         }
//       },
//       {
//         path: 'entry/edit',
//         component: () => import('@/views/encyclopedia/entry/EntryEdit.vue'),
//         name: 'encyclopediaEntryEdit',
//         meta: {
//           title: t('router.AddEncyclopediaEntry'),
//           noCache: true,
//           affix: true,
//           hideBreadcrumb:false,
//           hidden: true
//         }
//       },
//       {
//         path: 'entry/preview',
//         component: () => import('@/views/encyclopedia/entry/EntryPreview.vue'),
//         name: 'encyclopediaEntryPreview',
//         meta: {
//           title: t('router.encyclopediaEntry'),
//           noCache: true,
//           affix: true,
//           hideBreadcrumb:false,
//           hidden: true
//         }
//       },
//     ]
//   },
//   {
//     path: '/aiqa',
//     component: Layout,
//     redirect: '/mu-intelligent-agent',
//     name: 'AiPage',
//     meta: {
//       title: t('chat.intelligentEntity'),
//       icon: 'bx:bxs-component',
//       // alwaysShow: true
//     },
//     children: [
//       {
//         path: 'mu-intelligent-agent',
//         component: () => import('@/views/aiqa/mu/index.vue'),
//         name: 'muIntelligentAgent',
//         meta: {
//           title: t('router.muIntelAgent'),
//           noCache: true,
//           affix: true,
//           hideBreadcrumb:false
//         }
//       }
//     ]
//   },
//   // {
//   //   path: '/aiqa',
//   //   component: Layout,
//   //   redirect: '/aiqa/mu-intelligent-agent',
//   //   name: 'aiqa',
//   //   meta: {
//   //     title: t('router.aiQa'),
//   //     icon: 'bx:bxs-component',
//   //     alwaysShow: true
//   //   },  
//   //   children: [
//   //     {
//   //       path: 'mu-intelligent-agent',
//   //       component: () => import('@/views/aiqa/mu/index.vue'),
//   //       name: 'muIntelligentAgent',
//   //       meta: {
//   //         title: t('router.muIntelAgent'),
//   //         noCache: true,
//   //         affix: true,
//   //         hideBreadcrumb:false
//   //       }
//   //     },
//   //     {
//   //       path: 'fault-intelligent-agent',
//   //       component: () => import('@/views/aiqa/fault/index.vue'),
//   //       name: 'faultIntelligentAgent',
//   //       meta: {
//   //         title: t('router.faultIntelAgent'),
//   //         noCache: true,
//   //         affix: true,
//   //         hideBreadcrumb:false
//   //       }
//   //     },
//   //     {
//   //       path: 'doc-intelligent-agent',
//   //       component: () => import('@/views/aiqa/doc/index.vue'),
//   //       name: 'docIntelligentAgent',
//   //       meta: {
//   //         title: t('router.docIntelAgent'),
//   //         noCache: true,
//   //         affix: true,
//   //         hideBreadcrumb:false
//   //       }
//   //     },
//   //   ]
//   // },
//   {
//     path: '/system',
//     component: Layout,
//     redirect: '/system/basic',
//     name: 'SystemSetting',
//     meta: {
//       title: t('router.systemSetting'),
//       icon: 'bx:bxs-component',
//       alwaysShow: true
//     },  
//     children: [
//       {
//         path: 'basic',
//         component: () => import('@/views/system/Basic.vue'),
//         name: 'BasicSetting',
//         meta: {
//           title: t('router.basicSetting'),
//           noCache: true,
//           affix: true,
//           hideBreadcrumb:false
//         }
//       },
//     ]
//   },
// ]
export const asyncRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/agent',
    component: Layout,
    redirect: '/agent/mu',
    name: 'Agent',
    meta: {
      title: t('chat.intelligentEntity'),
      icon: 'bx:bxs-component',
      alwaysShow: false
    },
    children: [
      {
        path: 'mu',
        component: () => import('@/views/aiqa/mu/index.vue'),
        name: 'MuAgent',
        meta: {
          title: t('router.muIntelAgent'),
          noCache: true,
          affix: true,
          hideBreadcrumb:false
        }
      }
    ]
  },
  {
    path: '/doc',
    component: Layout,
    redirect: '/doc/list',
    name: 'DocLib',
    meta: {
      title: t('router.docLibrary'),
      icon: 'bx:bxs-component',
      alwaysShow: false
    },  
    children: [
      {
        path: 'list',
        component: () => import('@/views/doc/device/index.vue'),
        name: 'DocList',
        meta: {
          title: t('router.docLibrary'),
          noCache: true,
          affix: true,
          hideBreadcrumb:false
        }
      },
    ]
  },
  {
    path: '/encyclopedia',
    component: Layout,
    redirect: '/encyclopedia/entry',
    name: 'Encyclopedia',
    meta: {
      title: t('router.encyclopediaLibrary'),
      icon: 'bx:bxs-component',
      alwaysShow: false
    },  
    children: [
      {
        path: 'entry',
        component: () => import('@/views/encyclopedia/entry/index.vue'),
        name: 'EncyclopediaEntry',
        meta: {
          title: t('router.encyclopediaLibrary'),
          noCache: true,
          affix: true,
          hideBreadcrumb:false
        }
      },
      {
        path: 'entry/new',
        component: () => import('@/views/encyclopedia/entry/EntryEdit.vue'),
        name: 'EncyclopediaEntryAdd',
        meta: {
          title: t('router.AddEncyclopediaEntry'),
          noCache: true,
          affix: true,
          hideBreadcrumb:false,
          hidden: true
        }
      },
      {
        path: 'entry/edit',
        component: () => import('@/views/encyclopedia/entry/EntryEdit.vue'),
        name: 'EncyclopediaEntryEdit',
        meta: {
          title: t('router.EditEncyclopediaEntry'),
          noCache: true,
          affix: true,
          hideBreadcrumb:false,
          hidden: true
        }
      },
      {
        path: 'entry/preview',
        component: () => import('@/views/encyclopedia/entry/EntryPreview.vue'),
        name: 'EncyclopediaEntryPreview',
        meta: {
          title: t('router.encyclopediaEntry'),
          noCache: true,
          affix: true,
          hideBreadcrumb:false,
          hidden: true
        }
      },
    ]
  },
  {
    path: '/fault',
    component: Layout,
    redirect: '/fault/library',
    name: 'Fault',
    meta: {
      title: t('router.faultLibrary'),
      icon: 'bx:bxs-component',
      alwaysShow: false
    },  
    children: [
      {
        path: 'library',
        component: () => import('@/views/encyclopedia/fault/index.vue'),
        name: 'FaultLibrary',
        meta: {
          title: t('router.faultLibrary'),
          noCache: true,
          affix: true,
          hideBreadcrumb:false
        }
      },
    ]
  },
  {
    path: '/system',
    component: Layout,
    redirect: '/system/basic',
    name: 'SystemSetting',
    meta: {
      title: t('router.systemSetting'),
      icon: 'bx:bxs-component',
      alwaysShow: true
    },  
    children: [
      {
        path: 'basic',
        component: () => import('@/views/system/Basic.vue'),
        name: 'BasicSetting',
        meta: {
          title: t('router.basicSetting'),
          noCache: true,
          affix: true,
          hideBreadcrumb:false
        }
      },
      {
        path: 'agent',
        component: () => import('@/views/system/AgentSettings.vue'),
        name: 'AgentSettings',
        meta: {
          title: t('router.agentSettings'),
          noCache: true,
          affix: true,
          hideBreadcrumb:false
        }
      },
    ]
  },
  {
    path: '/embededpage',
    component: Layout,
    redirect: '/embededpage/docupload',
    name: 'EmbededPage',
    meta: {
      title: 'EmbededPage',
      icon: 'bx:bxs-component',
      alwaysShow: false
    },  
    children: [
      {
        path: 'docupload',
        component: () => import('@/views/embededpage/EmbededDocUpload.vue'),
        name: 'EmbededDocUpload',
        meta: {
          title: t('doc.docUpload'),
          noCache: true,
          affix: true,
          hideBreadcrumb:false
        }
      },
    ]
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export const resetRouter = (): void => {
  const resetWhiteNameList = ['Redirect', 'Login', 'NoFind', 'Root']
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !resetWhiteNameList.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
